module.exports = __webpack_public_path__ + "static/media/social_clicked.f282d5fa.png";